export default __webpack_public_path__ + "static/media/download-m2u.c0d199b1.png";